import React from "react";
import "../styles/MainSection.css";
import { useTranslation } from "react-i18next";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import { trackEvent } from "../utils/analytics";
import mainSectionVideo from "../assets/videos/mainSectionVideo1.mp4";
import StoreBadges from "./StoreBadges";

const APP_STORE_URL = "#";
const PLAY_STORE_URL = "#";

const MainSection = () => {
  const { t } = useTranslation();

  return (
    <section className="main-section">
      <video
        className="background-video"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src={mainSectionVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="main-overlay"></div>

      <div className="content">
        <h2>{t(`Premium Moroccan Matrimony`)}</h2>

        <p className="target-audience">
          {t(`A modern, private matchmaking app made for Moroccans.`)}
        </p>

        <p className="microline">
          {t(`Free to download · Built for marriage, not dating`)}
        </p>

        <StoreBadges className="hero-badges" location="in Hero" />
      </div>
    </section>
  );
};

export default MainSection;
